<template>
  <div class="d-flex flex-wrap justify-space-between">
    <div
      v-for="address in addresses"
      :key="address.id"
      :class="isMobile ? 'mb-6' : 'w-50 mb-6 pr-4'"
    >
      <h3
        v-if="address.title"
        data-qa="ceo-contact-address-title"
        class="text-h6 text--text mt-0 mb-3"
      >
        {{ transDynamic(address, `title,${language},${needTranslate}`) }}
      </h3>

      <p
        v-if="address.description"
        data-qa="ceo-contact-address-description"
        class="text-body-1 text-secondary--text mb-3"
      >
        {{ transDynamic(address, `description,${language},${needTranslate}`) }}
      </p>

      <p
        v-if="address.address"
        data-qa="ceo-contact-address-address"
        class="text-body-1 text--text mb-0"
      >
        {{ transDynamic(address, `address,${language},${needTranslate}`) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ContextStore } from 'src/components/pages/info/contacts/types'
import { useContextStore } from 'src/store'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'

const { context }: ContextStore = useContextStore()
const { language } = I18NextVue
const needTranslate = context.feature_flags.pd_l10n_footer_pages

const isMobile = computed(() => context?.flavour === 'mobile')

defineProps<{
  addresses: ContextStore['context']['company_ceo_contacts'][number]['addresses']['all']
}>()
</script>
